import { configureAccountStore } from '@state';
import React from 'react';
import { Provider } from 'react-redux';
import Tracking from '../tracking/Tracking';
const store = configureAccountStore();
const ClientServiceTracking = (props) => {
    return (React.createElement(Provider, { store: store },
        React.createElement("div", { className: "client-service" },
            React.createElement(Tracking, Object.assign({}, props)))));
};
export default ClientServiceTracking;
